// import { useEffect, useState } from 'react';

// export const useTheme = () => {
//     const [theme, setTheme] = useState<'light' | 'dark'>(() => {
//         const saved = localStorage.getItem('theme');
//         if (saved === 'light' || saved === 'dark') return saved;
//         return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
//     });

//     useEffect(() => {
//         // Aplicar el tema a CoreUI / HTML raíz
//         document.documentElement.setAttribute('data-coreui-theme', theme);
//         localStorage.setItem('theme', theme);
//     }, [theme]);

//     const toggleTheme = () => {
//         setTheme((prev) => (prev === 'light' ? 'dark' : 'light'));
//     };

//     return { theme, toggleTheme };
// };


// import { useEffect, useState } from 'react';

// export const useTheme = () => {
//     const [theme, setTheme] = useState<'light' | 'dark'>(() => {
//         const saved = localStorage.getItem('theme');
//         if (saved === 'light' || saved === 'dark') return saved;
//         return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
//     });

//     useEffect(() => {
//         // Aplica el tema en <html> y <body>
//         document.documentElement.setAttribute('data-coreui-theme', theme);
//         document.body.setAttribute('data-coreui-theme', theme);

//         // Si usas Bootstrap 5 estándar además de CoreUI
//         document.documentElement.setAttribute('data-bs-theme', theme);

//         localStorage.setItem('theme', theme);
//     }, [theme]);

//     const toggleTheme = () => {
//         setTheme((prev) => (prev === 'light' ? 'dark' : 'light'));
//     };

//     return { theme, toggleTheme };
// };

import { useEffect, useState } from 'react';

const THEME_EVENT = 'domicilapp-theme-change';

export const useTheme = () => {
    const [theme, setTheme] = useState<'light' | 'dark'>(() => {
        const saved = localStorage.getItem('theme');
        if (saved === 'light' || saved === 'dark') return saved;
        return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
    });

    useEffect(() => {
        // 1. Aplica el atributo de tema a HTML y Body para CoreUI Pro / Bootstrap
        document.documentElement.setAttribute('data-coreui-theme', theme);
        document.documentElement.setAttribute('data-bs-theme', theme);
        document.body.setAttribute('data-coreui-theme', theme);

        localStorage.setItem('theme', theme);
    }, [theme]);

    // Cada componente tiene su propia instancia del hook: se sincronizan con un evento
    // para que menú, gráficos y botón cambien juntos
    useEffect(() => {
        const onThemeChange = (event: Event) => setTheme((event as CustomEvent<'light' | 'dark'>).detail);
        window.addEventListener(THEME_EVENT, onThemeChange);
        return () => window.removeEventListener(THEME_EVENT, onThemeChange);
    }, []);

    const toggleTheme = () => {
        const next = theme === 'light' ? 'dark' : 'light';
        setTheme(next);
        window.dispatchEvent(new CustomEvent(THEME_EVENT, { detail: next }));
    };

    return { theme, toggleTheme };
};